const STEPS = [
  { color: "#0B8F7A", title: "Intake & verify", text: "Accept requests from web, email or portals. Verify identity before releasing personal data." },
  { color: "#2B6CB0", title: "Locate with Discovery", text: "Pull classified personal data linked to the Principal across structured and unstructured stores." },
  { color: "#6B46C1", title: "Cross-check consent", text: "Show active, withdrawn and expired consents so fulfilment aligns with purpose and rights." },
  { color: "#B45309", title: "Fulfil & respond", text: "Complete access packages, corrections or erasure — with SLA clocks and approver sign-off." },
  { color: "#15803D", title: "Close with evidence", text: "Archive a complete activity log — request, actions, artefacts and notifications — for audits." },
];

const RIGHTS = [
  { icon: "bi-eye", title: "Access", text: "Provide what data you hold and why" },
  { icon: "bi-pencil-square", title: "Correction", text: "Update inaccurate personal data" },
  { icon: "bi-trash", title: "Erasure", text: "Delete or anonymise on valid request" },
  { icon: "bi-toggle-off", title: "Withdraw consent", text: "Stop processing where consent was the basis" },
];

export default function DSAR() {
  return (
    <section id="dsar" className="py-20 bg-surface">
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Data Principal rights
        </p>
        <h2 className="font-bricolage text-[clamp(1.75rem,3vw,2.3rem)] mb-[0.7rem] text-ink">
          Complete DSAR activity in one workflow
        </h2>
        <p className="text-[1.05rem] leading-[1.65] text-slate max-w-[40rem]">
          Consent records feed directly into DSAR fulfilment. When a Data
          Principal requests access, correction or erasure, OneDPDP already
          knows what was consented — and where the data lives.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-[1.05fr_1fr] gap-10 items-start mt-10">
          <div className="flex flex-col">
            {STEPS.map((s, i) => (
              <div
                key={s.title}
                className="grid grid-cols-[48px_1fr] gap-4 py-[1.15rem] border-b border-line last:border-b-0"
              >
                <div
                  className="w-11 h-11 rounded-full flex items-center justify-center font-bricolage font-bold text-[0.95rem] text-white"
                  style={{ background: s.color }}
                >
                  {i + 1}
                </div>
                <div>
                  <h3 className="text-[1.05rem] font-bricolage font-semibold mb-[0.3rem]">{s.title}</h3>
                  <p className="m-0 text-slate text-[0.92rem] leading-[1.5]">{s.text}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="relative bg-ink text-white rounded-2xl p-[1.85rem_1.7rem] overflow-hidden">
            <div
              className="absolute -top-[20%] -right-[10%] w-[220px] h-[220px] pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(18,184,154,0.25), transparent 65%)" }}
            />
            <h3 className="relative text-[1.25rem] font-bricolage font-semibold mb-2">
              Rights you can run end-to-end
            </h3>
            <p className="relative text-white/60 text-[0.95rem] leading-[1.55] mb-[1.35rem]">
              Consent Management and DSAR share the same Principal profile —
              no hand-offs between tools.
            </p>
            <div className="relative grid grid-cols-2 gap-3">
              {RIGHTS.map((r) => (
                <div key={r.title} className="p-[0.9rem_0.95rem] rounded-lg bg-white/[.05] border border-white/10">
                  <i className={`bi ${r.icon} block text-[1.15rem] text-gold-bright mb-[0.45rem]`} />
                  <strong className="block text-[0.88rem] mb-[0.2rem]">{r.title}</strong>
                  <span className="text-[0.78rem] text-white/50 leading-[1.4]">{r.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
